import { useCallback, useMemo } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";

import { setTaskTab } from "../../../redux/SearchSlice";
import { setSideBarDrawer } from "../../../redux/Sidebar";
import { getLastSevenDays } from "../../../utils";
import {
  getMyTaskNavItems,
  isMyTaskQueryActive,
} from "../utils/myTaskUtils";

export function useMyTaskNavigation() {
  const dispatch = useDispatch();
  const location = useLocation();

  const navItems = useMemo(
    () =>
      getMyTaskNavItems().map((item) => ({
        ...item,
        to: item.isWorklog
          ? `/my-task?tab=worklog&${getLastSevenDays()}`
          : item.to,
        isActive: item.pathname
          ? location.pathname === item.pathname
          : isMyTaskQueryActive(location, item.query),
      })),
    [location]
  );

  const handleNavClick = useCallback(() => {
    dispatch(setTaskTab(true));
    dispatch(setSideBarDrawer(false));
  }, [dispatch]);

  return {
    navItems,
    handleNavClick,
  };
}
